export default "__VITE_ASSET__CHw_9a8k__"